// extracted by mini-css-extract-plugin
export const header = "custom-page-module--header--3AabY";
export const subtitle = "custom-page-module--subtitle--1zb-v";
export const slice = "custom-page-module--slice--nsff0";
export const youtubeVideo = "custom-page-module--youtubeVideo--I2Vvm";